// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:18:55

export default {
  "id": "merge-muscle",
  "slug": "merge-muscle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fe1b5a98d36940a380df978d8216c1e6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fe1b5a98d36940a380df978d8216c1e6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Muscle",
      "description": "Create the most powerful gym, connect athletes!  A large gym is at your disposal. Your task is to get new athletes, combine similar ones to get more powerful athletes. The most powerful athletes can be taken to a boxing competition. You need to click as often and quickly as possible to defeat your opponent in a difficult battle.  ",
      "instructions": "The goal of the game is to open all the characters, click to get new characters, connect the same ones to unlock stronger athletes. Control on a mobile device: touch. Controls on desktop: Left mouse button",
      "genres": [
        "Casual",
        "Sports"
      ],
      "tags": [
        "combat",
        "combine",
        "sport",
        "upgrade"
      ]
    },
    "zh-CN": {
      "title": "融合肌肉",
      "description": "创建最强大的健身房，连接运动员！一个大型健身房任你支配。你的任务是吸引新运动员，将相似的运动员组合起来，打造更强大的运动员。最强大的运动员可以参加拳击比赛。你需要尽可能频繁和快速地点击，以在艰难的战斗中击败你的对手。",
      "instructions": "游戏目标是解锁所有角色，点击获取新角色，连接相同的角色以解锁更强的运动员。移动设备上的控制：触摸。桌面上的控制：左鼠标键",
      "genres": [
        "休闲",
        "运动"
      ],
      "tags": [
        "战斗",
        "组合",
        "运动",
        "升级"
      ]
    },
    "zh-TW": {
      "title": "合體肌肉",
      "description": "創建最強的健身房，連結運動員！一個大健身房將在您手中。您的任務是招募新運動員，將相似的運動員結合以獲得更強大的運動員。最強大的運動員可以參加拳擊比賽。您需要盡可能快地點擊，以在激烈的戰鬥中擊敗對手。",
      "instructions": "遊戲的目標是打開所有角色，點擊獲得新角色，將相同的角色連接起來以解鎖更強壯的運動員。在行動裝置上的控制方式：觸碰。在桌面上遊戲的控制方式：左鍵滑鼠",
      "genres": [
        "休閒",
        "運動"
      ],
      "tags": [
        "作戰",
        "結合",
        "運動",
        "升級"
      ]
    },
    "zh-HK": {
      "title": "合體肌肉",
      "description": "創建最強的健身中心，連結運動員！一個大型的健身中心任君使用。你的任務是招募新運動員，將相似的運動員結合以創造更強大的運動員。最強大的運動員可以參加拳擊比賽。你需要盡可能地快和勤地點擊，以在艱難的戰鬥中擊敗對手。",
      "instructions": "遊戲的目標是打開所有角色，點擊以獲得新角色，將相同的角色連接起來以解鎖更強大的運動員。在移動設備上的控制：觸摸。在桌面上控制：左鍵鼠標",
      "genres": [
        "輕鬆",
        "運動"
      ],
      "tags": [
        "戰鬥",
        "組合",
        "運動",
        "升級"
      ]
    },
    "ja": {
      "title": "筋肉統合",
      "description": "最強のジムを作り、選手を結びつけよう！大きなジムがあなたの disposal（所有）にあります。あなたのタスクは新しい選手を獲得し、似た選手を組み合わせてより強力な選手を生み出すことです。最強の選手はボクシング大会に参加することができます。困難な戦いで敵を倒すためには、できるだけ頻繁にそして速くクリックする必要があります。",
      "instructions": "ゲームの目標は、すべてのキャラクターを開放し、新しいキャラクターを取得し、同じキャラクターを接続して強いアスリートを解放することです。モバイル機器での操作：タッチ。デスクトップでの操作：左クリック",
      "genres": [
        "カジュアル",
        "スポーツ"
      ],
      "tags": [
        "戦闘",
        "組み合わせ",
        "スポーツ",
        "アップグレード"
      ]
    },
    "ko": {
      "title": "마스클 합성",
      "description": "가장 강력한 체육관을 만들고, 운동선수들을 연결하세요! 대형 체육관이 여러분의 손에 있습니다. 여러분의 임무는 새로운 운동선수를 구하고, 유사한 선수들을 결합하여 더 강력한 운동선수를 만드는 것입니다. 가장 강력한 운동선수들은 박싱 경쟁으로 데려갈 수 있습니다. 어려운 전투에서 상대를 궁극적으로 궁복하기 위해 가장 빠르고 자주 클릭해야 합니다.",
      "instructions": "게임의 목표는 모든 캐릭터를 엽니다. 새로운 캐릭터를 얻으려면 클릭하세요. 같은 캐릭터를 연결하여 더 강한 운동선수를 해금하세요. 모바일 장치에서의 조작: 터치. 데스크톱에서의 조작: 왼쪽 마우스 버튼",
      "genres": [
        "캐주얼",
        "스포츠"
      ],
      "tags": [
        "전투",
        "결합",
        "스포츠",
        "업그레이드"
      ]
    },
    "fr": {
      "title": "Mélanger Muscle",
      "description": "Créez le gymnase le plus puissant, connectez les athlètes ! Un grand gymnase est à votre disposition. Votre tâche est de recruter de nouveaux athlètes, de les combiner pour obtenir des athlètes plus puissants. Les athlètes les plus puissants peuvent être envoyés dans une compétition de boxe. Vous devez cliquer le plus souvent et le plus rapidement possible pour vaincre votre adversaire dans une bataille difficile.",
      "instructions": "L'objectif du jeu est d'ouvrir tous les personnages, cliquer pour obtenir de nouveaux personnages, connecter les mêmes pour déverrouiller des athlètes plus forts. Contrôle sur appareil mobile : toucher. Contrôle sur ordinateur : bouton gauche de la souris.",
      "genres": [
        "Casual",
        "Sports"
      ],
      "tags": [
        "combat",
        "combinaison",
        "sport",
        "mise à niveau"
      ]
    }
  }
};
